export default "__VITE_ASSET__D6XiJ7ks__"